(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kiyoh-testimonials-masonry"] && !Shopify.designMode) return;
  try {
    
  const STAR_SVG = '<svg class="icon icon-star icon--small" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 0.5L10.0784 5.63932L15.6085 6.02786L11.3629 9.59268L12.7023 14.9721L8 12.036L3.29772 14.9721L4.63706 9.59268L0.391548 6.02786L5.92159 5.63932L8 0.5Z" fill="currentColor"/></svg>';

  class KiyohTestimonials extends HTMLElement {
    connectedCallback() {
      this.fetchReviews();
    }

    async fetchReviews() {
      const feedUrl = this.dataset.feedUrl;
      if (!feedUrl) return;

      try {
        const response = await fetch(feedUrl);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const xmlText = await response.text();
        const parser = new DOMParser();
        const xml = parser.parseFromString(xmlText, 'text/xml');
        const reviews = xml.querySelectorAll('reviews > reviews');

        if (!reviews.length) return;

        const colorScheme = this.dataset.cardColorScheme || 'scheme-1';
        const hasBg = this.dataset.cardHasBg === 'true';
        const masonry = this.querySelector('masonry-layout');
        const fragment = document.createDocumentFragment();

        reviews.forEach((review, index) => {
          const author = this.getText(review, 'reviewAuthor');
          const city = this.getText(review, 'city');
          const rating = parseInt(this.getText(review, 'rating'), 10) || 0;
          const stars = Math.min(5, Math.max(0, Math.round(rating / 2)));

          let reviewText = '';
          review.querySelectorAll('reviewContent > reviewContent').forEach((rc) => {
            if (rc.querySelector('questionGroup')?.textContent === 'DEFAULT_OPINION') {
              reviewText = rc.querySelector('rating')?.textContent || '';
            }
          });

          if (!reviewText) return;

          const col = document.createElement('div');
          col.className = 'f-column';
          col.dataset.index = index;

          const bgClass = hasBg ? ' testimonial--has-bg blocks-radius' : '';
          const starsHtml = stars > 0
            ? `<div class="testimonial__icon">${STAR_SVG.repeat(stars)}</div>`
            : '';

          const authorHtml = author || city
            ? `<div class="testimonial__author inline-flex items-center gap-x-3">
                <div class="testimonial__info text-left flex gap-x-2 gap-y-1 flex-col">
                  ${author ? `<h3 class="testimonial__name h5">${this.escapeHtml(author)}</h3>` : ''}
                  ${city ? `<div class="testimonial__bio text-subtext text-sm">${this.escapeHtml(city)}</div>` : ''}
                </div>
              </div>`
            : '';

          col.innerHTML = `
            <div class="testimonial testimonial--layout-2${bgClass} color-${colorScheme} h-full flex flex-col">
              <div class="testimonial__wrapper">
                <div class="testimonial__inner">
                  ${authorHtml}
                  ${starsHtml}
                  <div class="testimonial__content rte text-base text-subtext">
                    <p>${this.escapeHtml(reviewText)}</p>
                  </div>
                </div>
              </div>
            </div>`;

          col._review = { author, city, stars, reviewText };
          fragment.appendChild(col);
        });

        masonry.appendChild(fragment);

        // On mobile the reviews are a horizontal swipe slider, so a "view more"
        // button that reveals extra slides feels odd — let users just swipe
        // through all of them. The limit + button only apply on desktop.
        const isMobile = window.matchMedia('(max-width: 767.98px)').matches;
        const initialCount = parseInt(this.dataset.initialCount, 10) || 0;
        let cols = masonry.querySelectorAll('.f-column');

        // Desktop: max aantal reviews toepassen en afronden naar beneden op een
        // veelvoud van het aantal kolommen, zodat de laatste rij altijd vol is.
        const columns = parseInt(this.dataset.columns, 10) || 0;
        const maxReviews = parseInt(this.dataset.maxReviews, 10) || 0;
        if (!isMobile && cols.length > 1) {
          let limit = cols.length;
          if (maxReviews > 0) limit = Math.min(limit, maxReviews);
          if (columns > 1) limit = Math.floor(limit / columns) * columns;
          if (limit > 0 && limit < cols.length) {
            cols.forEach((col, i) => {
              if (i >= limit) col.remove();
            });
            cols = masonry.querySelectorAll('.f-column');
          }
        }
        if (!isMobile && initialCount > 0 && cols.length > initialCount) {
          cols.forEach((col, i) => {
            if (i >= initialCount) col.style.display = 'none';
          });

          const btnWrap = document.createElement('div');
          btnWrap.className = 'kiyoh-testimonials__more flex justify-center';
          const viewMoreText = this.escapeHtml(this.dataset.viewMoreText || 'Bekijk meer');
          const viewLessText = this.escapeHtml(this.dataset.viewLessText || 'Toon minder');
          btnWrap.innerHTML = `<button type="button" class="btn btn--primary"><span class="btn__text">${viewMoreText}</span></button>`;

          const btnText = btnWrap.querySelector('.btn__text');
          let expanded = false;

          btnWrap.querySelector('button').addEventListener('click', () => {
            expanded = !expanded;
            cols.forEach((col, i) => {
              col.style.display = expanded || i < initialCount ? '' : 'none';
            });
            btnText.textContent = expanded ? viewLessText : viewMoreText;
            if (typeof masonry.layout === 'function') masonry.layout();

            // Bij inklappen terug naar de bovenkant van de sectie scrollen,
            // anders blijft de gebruiker onderaan een veel kortere lijst hangen.
            if (!expanded) {
              const section = this.closest('.section');
              if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          });

          // Mount the button outside the (mobile) slider so it sits below the
          // reviews instead of floating in the middle of the slider.
          const mountPoint = this.closest('.section__content') || this;
          mountPoint.appendChild(btnWrap);
        }

        if (typeof masonry.layout === 'function') {
          masonry.layout();
        }

        // Mobile: add a "Lees meer" link to cards whose (clamped) text overflows,
        // opening the full review in a popup.
        if (window.matchMedia('(max-width: 767.98px)').matches) {
          requestAnimationFrame(() => this.setupReadMore(cols));
        }
      } catch (e) {
        console.warn('Kiyoh feed fetch failed:', e);
      }
    }

    setupReadMore(cols) {
      cols.forEach((col) => {
        const content = col.querySelector('.testimonial__content');
        const inner = col.querySelector('.testimonial__inner');
        if (!content || !inner) return;
        if (content.scrollHeight <= content.clientHeight + 2) return; // not clamped

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kiyoh-review__more btn btn--underline';
        btn.innerHTML = '<span class="btn__text">Lees meer</span>';
        btn.addEventListener('click', () => this.openModal(col._review));
        inner.appendChild(btn);
      });
    }

    ensureModal() {
      if (this._modal) return this._modal;
      const modal = document.createElement('div');
      modal.className = 'kiyoh-review-modal';
      modal.innerHTML = `
        <div class="kiyoh-review-modal__overlay"></div>
        <div class="kiyoh-review-modal__dialog" role="dialog" aria-modal="true">
          <button type="button" class="kiyoh-review-modal__close" aria-label="Sluiten">&times;</button>
          <div class="kiyoh-review-modal__stars"></div>
          <h3 class="kiyoh-review-modal__name h5"></h3>
          <div class="kiyoh-review-modal__city text-subtext text-sm"></div>
          <div class="kiyoh-review-modal__text rte text-subtext"></div>
        </div>`;
      const close = () => this.closeModal();
      modal.querySelector('.kiyoh-review-modal__overlay').addEventListener('click', close);
      modal.querySelector('.kiyoh-review-modal__close').addEventListener('click', close);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
      });
      document.body.appendChild(modal);
      this._modal = modal;
      return modal;
    }

    openModal(data) {
      if (!data) return;
      const modal = this.ensureModal();
      modal.querySelector('.kiyoh-review-modal__name').textContent = data.author || '';
      modal.querySelector('.kiyoh-review-modal__city').textContent = data.city || '';
      modal.querySelector('.kiyoh-review-modal__stars').innerHTML = data.stars > 0 ? STAR_SVG.repeat(data.stars) : '';
      modal.querySelector('.kiyoh-review-modal__text').textContent = data.reviewText || '';
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => modal.classList.add('is-open'));
    }

    closeModal() {
      if (this._modal) this._modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    getText(el, tag) {
      const node = el.querySelector(':scope > ' + tag);
      return node ? node.textContent.trim() : '';
    }

    escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }
  }

  customElements.define('kiyoh-testimonials', KiyohTestimonials);

  } catch(e) { console.error(e); }
})();
})();
